import React, { useEffect, useState } from "react";
import { getAllGallery } from "../../api/apiHandler";
import heroImg from "../../Assets/images/gettyimg.jpg";


const staticPhotos = [
  { id: 1, src: "https://c.saavncdn.com/413/Chuglan-Ne-Chugli-Kari-Hardol-Ka-Bhaat-Bundeli-Kissa-Hindi-2011-20220826190132-500x500.jpg", title: "Bundelkhand Event" },
  { id: 2, src: "https://media.assettype.com/thequint%2F2025-09-10%2Fmd3rw2pq%2FUntitled-design-53.jpg?auto=format%2Ccompress&fmt=webp&width=720", title: "Ground Report" },
  { id: 3, src: "https://s.wsj.net/public/resources/images/BN-UU084_NYVOIC_M_20170822141145.jpg", title: "Public Voice" },
  { id: 4, src: "https://media.assettype.com/outlookindia/import/public/uploads/articles/2019/11/24/deccan.jpg?w=801&auto=format%2Ccompress&fit=max&format=webp&dpr=1.0", title: "Political Coverage" },
  
];

const ITEMS_PER_LOAD = 9;
const BACKEND = process.env.REACT_APP_BACKEND_URL?.replace("/api/v1/", "") || "";


const Photos = () => {
  const [dynamicPhotos, setDynamicPhotos] = useState([]);
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_LOAD);

  // 🔥 Fetch admin gallery
  useEffect(() => {
    getAllGallery()
      .then((res) => {
              console.log("Gallery API data:", res.data); // ✅ PUT HERE

        if (Array.isArray(res.data)) {
          setDynamicPhotos(res.data);
        }
      })
      .catch((err) => console.error("Gallery fetch error:", err));
  }, []);

  // 🔥 Merge STATIC + DYNAMIC
const dynamicGalleryPhotos = Array.isArray(dynamicPhotos)
  ? dynamicPhotos
      .filter(item => item.image) 
      .map(item => ({
        id: `d-${item.id}`,
        title: item.name || "Gallery Image",
        src: `${BACKEND}/gallery/${item.image}`,
      }))
  : [];

const allPhotos = [...staticPhotos, ...dynamicGalleryPhotos];
console.log("Merged photos:", allPhotos);


  const handleViewMore = () => {
    setVisibleCount((prev) => prev + ITEMS_PER_LOAD);
    
  };

  return (
    <section>
      {/* HERO */}
      <div className="relative h-[340px] w-full">
        {/* <img
          src="https://media.gettyimages.com/id/541903912/video/4k-red-streaks-light-animation-background-seamless-loop.jpg"
          alt="gallery"
          className="w-full h-full object-cover"
        /> */}
 <img
  src={heroImg}
  alt="Photo Gallery"
  className="w-full h-full object-center object-cover scale-[1.02]"
/>


        <div className="absolute inset-0 bg-black/70 flex flex-col items-center justify-center text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl font-bold">
            Photo Gallery
          </h1>
          <p className="mt-4 max-w-xl text-gray-300 text-sm">
            Real stories captured from ground-level journalism
          </p>
        </div>
      </div>

      {/* GRID */}
      <div className="py-20 max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {allPhotos.slice(0, visibleCount).map((photo) => (
            <div
              key={photo.id}
              className="group relative rounded-2xl overflow-hidden
              bg-white shadow-md hover:shadow-2xl
              transition-all duration-500 hover:-translate-y-2"
            >
              <a
                href={photo.src}
                target="_blank"
                rel="noopener noreferrer">
                <img
                  src={photo.src}
                  alt={photo.title}
                  className="w-full h-64 object-cover
                transition-transform duration-700 group-hover:scale-110"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/no-image.png";
                  }}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t
                from-slate-900/80 via-slate-900/30 to-transparent
                opacity-0 group-hover:opacity-100 transition duration-500" />

              <div className="absolute bottom-0 left-0 right-0 p-5
                translate-y-8 opacity-0
                group-hover:opacity-100 group-hover:translate-y-0
                transition duration-500">
                <h3 className="text-white text-lg font-semibold">
                  {photo.title}
                </h3>
                <p className="text-amber-400 text-sm">
                  View full image
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* VIEW MORE */}
        {visibleCount < allPhotos.length && (
          <div className="mt-20 text-center">
            <button
              onClick={handleViewMore}
              className="px-12 py-4 rounded-full
              bg-gradient-to-r from-red-700 to-amber-600
              text-white text-lg font-semibold
              shadow-xl hover:shadow-2xl
              transition-all duration-300"
            >
              View More Images
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Photos;
